// extracted by mini-css-extract-plugin
export var capabilities = "capabilities-module--capabilities--2zTqs";
export var capabilitiesDesktop = "capabilities-module--capabilities-desktop--zvW0H";
export var capabilitiesMobile = "capabilities-module--capabilities-mobile--HVI3B";
export var columnContent = "capabilities-module--column-content--atqq8";
export var columnMenu = "capabilities-module--column-menu--WbHfr";
export var menuItem = "capabilities-module--menu-item--KwDaU";
export var menuItemActive = "capabilities-module--menu-item-active--3kEPP";